/**
 * An object that contains a min and max screensize,
 * as well as methods to check if the window is in range
 * of those screensizes.
 *
 * @since 1.0.0
 *
 * @type {Class}
 */
export class Breakpoint {
	constructor(min, max) {
		this.min = min;
		this.max = max;
	}

	aboveMin() {
		return window.innerWidth >= this.min;
	}

	belowMax() {
		return window.innerWidth <= this.max;
	}

	inRange() {
		return this.aboveMin() && this.belowMax();
	}
}

/**
 * A collection of Breakpoint objects for easy access in your project.
 * Best if these match the breakpoint values you setup in your CSS.
 *
 * @since 1.0.0
 *
 * @type {Class}
 */
export class Breakpoints {
	constructor(sizes) {
		const defaults = [
			{
				key: 'xxs',
				min: 320,
			},
			{
				key: 'xs',
				min: 480,
			},
			{
				key: 'sm',
				min: 768,
			},
			{
				key: 'md',
				min: 1114,
			},
			{
				key: 'lg',
				min: 1200,
			},
		];

		this.sizes = sizes || defaults;

		for (let i = 0; i < this.sizes.length; i++) {
			const { key } = this.sizes[i];
			const { min } = this.sizes[i];
			const max = this.sizes[i].max ? this.sizes[i].max : (this.sizes[i + 1] ? this.sizes[i + 1].min - 1 : Infinity); // eslint-disable-line
			this[key] = new Breakpoint(min, max);
		}
	}
}
